
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiSignLiferaft as ObiSignLiferaftElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-sign-liferaft.js';
 
 
 

 
 export const ObiSignLiferaft = createComponent({
   react: React,
   tagName: 'obi-sign-liferaft',
   elementClass: ObiSignLiferaftElement,
   events: {
     
   }
  });
 
 